<template>
  <q-avatar
    :key="localInitials"
    size="32px"
    text-color="white"
    :style="getAvatarStyle(localFullname)"
  >
    {{ localInitials }}
  </q-avatar>
</template>

<script lang="ts">
import { Prop, Watch, Vue } from "vue-property-decorator";
import GeoPattern from "geopattern";

export default class App extends Vue {
  name = "IstAvatar";
  localFullname = "";
  localInitials = "";

  @Prop({ default: "" })
  fullname!: string;
  @Prop({ default: "" })
  initials!: string;

  @Prop({ default: null })
  employee!: any;

  mounted() {
    this.localFullname = this.fullname;
    if (this.employee) {
      this.localFullname = this.employee.display_name;
    }
    if (this.initials?.length == 0) {
      this.localInitials = this.getInitials(this.localFullname);
    }
  }

  getAvatarStyle(name: string) {
    var pattern = GeoPattern.generate(name);
    return {
      "background-image": pattern.toDataUrl(),
      float: "left"
    };
  }

  @Watch("fullname")
  onfullnameChange(newValue, oldValue) {
    if (oldValue !== newValue) {
      this.localFullname = newValue;
      this.localInitials = this.getInitials(this.localFullname);
    }
  }

  getInitials(name) {
    name = name.trim();
    const FirstName = name.split(" ")[0];
    const LastName = name.split(" ").reduceRight((a) => a);
    // Extract the first two characters of a string
    if (FirstName === LastName) {
      return FirstName.trim().substring(0, 2).toUpperCase();
    }

    // Abbreviate FirstName and LastName
    return [FirstName, LastName]
      .map((name) => name[0])
      .join("")
      .toUpperCase();
  }
}
</script>

<style></style>
